import { useEffect, useState } from "react";

const useProgressiveImg = (lowQualitySrc, highQualitySrc) => {
  const [src, setSrc] = useState(lowQualitySrc);

  useEffect(() => {
    setSrc(lowQualitySrc);
    const image = new Image();

    image.onload = () => {
      setSrc(highQualitySrc);
    };
    image.src = highQualitySrc;

    return () => {
      image.onload = null;
    };
  }, [lowQualitySrc, highQualitySrc]);

  return [src, { blur: src === lowQualitySrc }];
};

export default useProgressiveImg;
